<template>
    <footer class="border-t border-app pt-20 pb-10 bg-card">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
                <!-- Brand Info -->
                <div class="col-span-2">
                    <div class="flex items-center gap-2 mb-6">
                        <!-- <div class="h-8 w-auto flex items-center justify-center">
                            <BrandLogo class="w-32 h-12"></BrandLogo>
                        </div> -->
                        <span class="text-xl font-bold text-header">{{ webConfig.tenantName }}</span>
                    </div>
                    <div class="text-muted text-sm leading-relaxed mb-6" v-html="webConfig.bio"></div>
                    <div class="flex gap-4">
                        <a v-for="(item, index) in webConfig.socialMenu" :key="index" :href="item.link"
                            class="h-10 w-10 rounded-full border border-app flex items-center justify-center text-muted hover:text-brand-500 hover:border-brand-500 transition-all cursor-pointer">
                            <i :class="item.icon" class="h-5 w-5"></i>
                        </a>
                    </div>
                </div>

                <div class="grid gap-12 col-span-2 md:col-span-3 lg:col-span-3" :class="{
                    'grid-cols-2 md:grid-cols-3 lg:grid-cols-3': activeLinkColumns.length > 3,
                    'grid-cols-1 md:grid-cols-2 lg:grid-cols-2': activeLinkColumns.length == 2,
                    'grid-cols-1 md:grid-cols-2': activeLinkColumns.length == 1,
                }">
                    <!-- Links Columns -->
                    <template v-for="column in activeLinkColumns" :key="column.title">
                        <template v-if="props.webConfig[column.links].length > 0">
                            <div>
                                <h4 class="font-bold text-header mb-6">{{ column.title }}</h4>
                                <ul class="space-y-4 text-sm text-muted">

                                    <li v-for="link in props.webConfig[column.links]" :key="link.name">
                                        <NuxtLink v-if="['default', 'page'].includes(link.type)" :to="link.link"
                                            class="hover:text-brand-500 transition-colors"
                                            active-class="text-brand-500 font-bold">
                                            {{ link.name }}
                                        </NuxtLink>
                                        <a v-else :href="link.link" class="hover:text-brand-500 transition-colors">
                                            {{ link.name }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </template>
                </div>
            </div>

            <!-- Bottom Bar -->
            <div class="pt-10 border-t border-app text-center md:flex md:justify-between md:items-center">
                <p class="text-xs text-muted font-medium">&copy; 2026 Core Global Inc. All rights reserved.</p>
                <div class="mt-4 md:mt-0 flex justify-center gap-6 text-xs text-muted">
                    <template v-for="link in webConfig.footerMenu" :key="link.id ">
                        <NuxtLink v-if="['default', 'page'].includes(link.type)" :to="link.link"
                            class="hover:text-brand-500" active-class="text-brand-500 font-bold">
                            {{ link.name }}
                        </NuxtLink>
                        <a v-else :href="link.link" class="hover:text-brand-500">
                            {{ link.name }}
                        </a>
                    </template>
                    <a :href="targetUrl" class="hover:text-brand-500">
                        Admin Dashboard
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import BrandLogo from '@core/components/BrandLogo.vue';

import { MenuItem, WebConfig } from '@core/stores/types';
import { computed } from 'vue';
const props = defineProps<{ webConfig: WebConfig }>()

const linkColumns = [
    {
        title: 'Ecosystem',
        links: "ecosystemMenu"
    },
    {
        title: 'Support',
        links: 'supportMenu'
    },
    {
        title: 'Company',
        links: 'companyMenu'
    },
]

const activeLinkColumns = computed(() => {
    return linkColumns.filter((column) => props.webConfig[column.links].length > 0)
})

const subDomain = computed<string>(() => {
    return `${window.location.protocol}//${window.location.host}`
})

const targetUrl = computed(() => {
    var prefixUrl = import.meta.dev ? '/dev' : '';
    return `${subDomain.value}${prefixUrl}/auth/apps`
})
</script>

<style scoped>
.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.border-app {
    border-color: rgb(var(--core-app-border));
}

.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}
</style>
